@if (contactsViewType === 'card') {
    <div class="contact-cards-grid">
        <div class="contact-card">
            <div class="contact-card__header">
                <h3 class="contact-card__title">{{ block.data?.heading }}</h3>
            </div>
            <div class="contact-card__body">
                @for (contact of contacts; track $index) {
                    <div class="contact-card__contact">
                        <h4 class="contact-card__contact-title">{{ contact.benefitName || contact.heading }}</h4>

                        @if (contact.websiteUrl) {
                            <div class="contact-card__contact-info">
                                <a [href]="contact.websiteUrl" target="_blank" rel="noopener noreferrer">
                                    {{
                                        contact.websiteText ||
                                            contact.websiteUrl.replace('https://', '').replace('http://', '')
                                    }}
                                </a>
                            </div>
                        }

                        @if (contact.phone) {
                            <div class="contact-card__contact-info">
                                Call: <strong>{{ contact.phone }}</strong>
                            </div>
                        }

                        @if (contact.appleAppUrl || contact.androidAppUrl) {
                            <div class="contact-card__contact-apps">
                                @if (contact.appleAppUrl) {
                                    <div class="contact-card__contact-info">
                                        <a [href]="contact.appleAppUrl" target="_blank" rel="noopener noreferrer">
                                            App Store
                                        </a>
                                    </div>
                                }
                                @if (contact.appleAppUrl && contact.androidAppUrl) {
                                    <span class="separator">·</span>
                                }
                                @if (contact.androidAppUrl) {
                                    <div class="contact-card__contact-info">
                                        <a [href]="contact.androidAppUrl" target="_blank" rel="noopener noreferrer">
                                            Google Play
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    @if (hasContactsArray()) {
        @for (contact of contacts; track $index) {
            <button [attr.aria-controls]="modalId()" (click)="openModal(contact)" class="contact-modal-button">
                <div class="contact-modal-button__content">
                    <span
                        class="contact-modal-button__heading"
                        [innerHTML]="contact.benefitName || block.data?.heading"></span>
                    <span
                        class="contact-modal-button__subheading"
                        [innerHTML]="contact.vendor || block.data?.subheading"></span>
                </div>
                <core-icon [name]="tileIcon" class="contact-modal-button__icon" [size]="[18, 18]"></core-icon>
            </button>
        }

        <core-modal
            class="contact-modal-wrapper"
            #coreModal
            [id]="modalId()"
            [title]="selectedContact()?.vendor"
            [eyebrow]="selectedContact()?.benefitName"
            [showHeaderDivider]="false">
            @if (selectedContact(); as contact) {
                <div class="contact-modal-content">
                    <div class="contact-modal-providers">
                        <div class="contact-modal-providers-list">
                            @if (contact.websiteUrl) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Website</h4>
                                    <div class="contact-modal-item__value">
                                        <a
                                            [href]="contact.websiteUrl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="contact-modal-link">
                                            {{
                                                contact.websiteText ||
                                                    contact.websiteUrl.replace('https://', '').replace('http://', '')
                                            }}
                                        </a>
                                        @if (contact.websiteInfo) {
                                            <div class="contact-modal-item__subtext">
                                                {{ contact.websiteInfo }}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }

                            @if (contact.groupNumber) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Group Number</h4>
                                    <div class="contact-modal-item__value">
                                        {{ contact.groupNumber }}
                                    </div>
                                </div>
                            }

                            @if (contact.phone) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Phone</h4>
                                    <div class="contact-modal-item__value">
                                        <a [href]="'tel:' + contact.phone">{{ contact.phone }}</a>
                                    </div>
                                </div>
                            }

                            @if (contact.email) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Email</h4>
                                    <div class="contact-modal-item__value">
                                        <a [href]="'mailto:' + contact.email" class="contact-modal-link">{{
                                            contact.email
                                        }}</a>
                                    </div>
                                </div>
                            }

                            @if (contact.address) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Address</h4>
                                    <div class="contact-modal-item__value" [innerHTML]="contact.address"></div>
                                </div>
                            }

                            @if (contact.notes) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Notes</h4>
                                    <div class="contact-modal-item__value" [innerHTML]="contact.notes"></div>
                                </div>
                            }

                            @if (contact.appleAppUrl) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Download App</h4>
                                    <div class="contact-modal-item__value">
                                        <a
                                            [href]="contact.appleAppUrl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="contact-modal-link">
                                            {{ contact.appleAppLabel || 'Apple' }}
                                        </a>
                                    </div>
                                </div>
                            }

                            @if (contact.androidAppUrl) {
                                <div class="contact-modal-item">
                                    <h4 class="contact-modal-item__label">Download App</h4>
                                    <div class="contact-modal-item__value">
                                        <a
                                            [href]="contact.androidAppUrl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="contact-modal-link">
                                            {{ contact.androidAppLabel || 'Android' }}
                                        </a>
                                    </div>
                                </div>
                            }

                            @if (contact.providers) {
                                @for (provider of contact.providers; track $index) {
                                    <div class="contact-modal-item">
                                        <h4 class="contact-modal-item__label">{{ provider.title | uppercase }}</h4>
                                        @if (provider.description) {
                                            <div
                                                class="contact-modal-item__value"
                                                [innerHTML]="provider.description"></div>
                                        }
                                    </div>
                                }
                            }
                        </div>
                    </div>
                </div>
            }
        </core-modal>
    }
}
